<template>
  <card-seplag titulo="Agendamento de Licença Prêmio">

    <template>
    <Card v-if="!habilitaAgendamento" class="p-col-12">
      <template #content>
        <p class="p-text-center">
          Solicitação de usufruto de Licença-prêmio, favor entrar em contato com
          sua setorial de Gestão de Pessoas.
        </p>
      </template>
    </Card>
    <Rotulo cols="12 4" v-if="habilitaAgendamento">
      <Fieldset legend="Selecione um quinquênio:">
        <Rotulo nome="Quinquênio(s) com saldo">
          <Dropdown
            v-model="selectedPeriodoAquisitivo"
            :options="periodosAquisitivos"
            optionLabel="descPeriodo"
            placeholder="Selecione um quinquênio"
            :filter="false"
            :showClear="true"
            @input="carregarCamposAgendamento()"
          >
          </Dropdown>
        </Rotulo>
        <br /><br />
        <Rotulo nome="Saldo de dias de direito">
          <InputText
            type="button"
            disabled="true"
            v-model="this.saldoDias"
            id="input_mostra_dias"
          />
        </Rotulo>
        <br />
      </Fieldset>
    </Rotulo>
    <Rotulo cols="12 8">
      <Fieldset
        legend="Selecione a quantidade de dias pretendidos:"
        v-if="tiposGozo && tiposGozo.length > 0"
      >
        <SelectButton
          v-model="selectedTipoGozo"
          :options="tiposGozo"
          optionLabel="name"
          @input="calcularData()"
        />
        <br />
        <div
          class="p-grid"
          v-if="selectedTipoGozo && selectedTipoGozo.code != null"
        >
          <Rotulo
            nome="Converter em redução de jornada?"
            class="p-align-center p-justify-center"
            cols="12"
            style="text-align: center"
            v-if="selectedTipoGozo && selectedTipoGozo.code >= 30"
          >
            <InputSwitch
              v-model="checkReducaoJornada"
              @input="() => { calcularData(); carregarMaxDate(); }"
            />
            <div v-if="this.checkReducaoJornada == true">Sim</div>
            <div v-if="this.checkReducaoJornada == false">Não</div>
          </Rotulo>
          <Rotulo
            nome="Periodo em que vai trabalhar"
            class="p-align-center p-justify-center"
            cols="12"
            style="text-align: center; margin-bottom: 10px"
            v-if="
              selectedTipoGozo &&
              selectedTipoGozo.code >= 30 &&
              this.checkReducaoJornada == true
            "
          >
            <SelectButton
              v-model="periodoJornadaSelecionada"
              :options="listaPeriodoJornadaReduzida"
            />
          </Rotulo>
          <Rotulo name="" cols="12 2" style="margin-top: 1.8%">
            <div
              style="
                background-color: #b7d8b7;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 10 &&
                this.checkReducaoJornada == false
              "
            >
              <b>10</b> dias corridos
            </div>
            <div
              style="
                background-color: #b7d8b7;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 10 &&
                this.checkReducaoJornada == true
              "
            >
              <b>20</b> dias corridos
            </div>
            <div
              style="
                background-color: #7fbcec;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 15 &&
                this.checkReducaoJornada == false
              "
            >
              <b>15</b> dias corridos
            </div>
            <div
              style="
                background-color: #b7d8b7;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 15 &&
                this.checkReducaoJornada == true
              "
            >
              <b>30</b> dias corridos
            </div>
            <div
              style="
                background-color: #ffe399;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 20 &&
                this.checkReducaoJornada == false
              "
            >
              <b>20</b> dias corridos
            </div>
            <div
              style="
                background-color: #ffe399;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 20 &&
                this.checkReducaoJornada == true
              "
            >
              <b>40</b> dias corridos
            </div>
            <div
              style="
                background-color: #b7d8b7;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 30 &&
                this.checkReducaoJornada == false
              "
            >
              <b>30</b> dias corridos
            </div>
            <div
              style="
                background-color: #b7d8b7;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 30 &&
                this.checkReducaoJornada == true
              "
            >
              <b>60</b> dias corridos
            </div>
            <div
              style="
                background-color: #7fbcec;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 60 &&
                this.checkReducaoJornada == false
              "
            >
              <b>60</b> dias corridos
            </div>
            <div
              style="
                background-color: #7fbcec;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 60 &&
                this.checkReducaoJornada == true
              "
            >
              <b>120</b> dias corridos
            </div>
            <div
              style="
                background-color: #ffe399;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 90 &&
                this.checkReducaoJornada == false
              "
            >
              <b>90</b> dias corridos
            </div>
            <div
              style="
                background-color: #ffe399;
                text-align: center;
                padding: 6px;
              "
              v-if="
                selectedTipoGozo &&
                selectedTipoGozo.code == 90 &&
                this.checkReducaoJornada == true
              "
            >
              <b>180</b> dias corridos
            </div>
          </Rotulo>
          <Rotulo nome="Data de início" id="integral_inicio" cols="12 5">
            <v-date-picker
              v-model="data_inicio"
              @input="calcularData()"
              :max-date="max_date"
              :min-date="min_date"
              :model-config="datePikerConfig"
              :update-on-input="false"
              :masks="datePikermasks"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-inputmask p-inputtext p-component"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
            <!-- <Calendar   :showIcon="true" dateFormat="dd/mm/yy" v-model="data_inicio"  @input="calcularData()" /> -->
          </Rotulo>
          <Rotulo nome="Data de término" id="integral_fim" cols="12 4">
            <InputMask
              mask="99/99/9999"
              placeholder="dd/mm/aaaa"
              v-model="data_fim"
              disabled="true"
            />
            <!-- <Calendar   :showIcon="true" dateFormat="dd/mm/yy" v-model="data_fim" disabled="true"/> -->
          </Rotulo>

          <Rotulo nome="Agendar" cols="12 1" style="text-align: center">
            <Button
              type="button"
              icon="pi pi-check"
              class="p-button-info"
              @click="adicionarRegistro()"
            />
          </Rotulo>
        </div>
        <div class="p-grid" v-else>
          <h3>Selecione a Quantidade de Dias Pretendidos.</h3>
        </div>
      </Fieldset>
    </Rotulo>
    <table-seplag
      :dados="agendamentos"
      :exibirCabecalho="false"
      :campos="colunasTabela"
      :paginacao="false"
    >
      <Column
        field="status"
        header="Situação"
        headerClass="situacaoColunaFeriasAgendamento"
        bodyClass="botaoColunaSituacaoFeriasAgendamento"
      >
        <template #body="slotProps">
          <Button
            :class="'p-button-text status-' + slotProps.data.status"
            type="button"
            @click="showModalJustificativa(slotProps.data.observacao)"
            v-tooltip.top="
              slotProps.data.observacao
                ? 'Ver Justificativa'
                : 'Não Possui Justificativa'
            "
            :label="
              slotProps.data.status == 'VALIDADO'
                ? 'NO SEAP'
                : slotProps.data.status == 'APROVADORH'
                ? 'APROVADO'
                : slotProps.data.status
            "
          />
        </template>
      </Column>
      <Column field="aprovador" header="Aprovador">
        <template #body="slotProps">
          <div class="colunaAprovador">
            <span v-if="slotProps.data.status == 'PENDENTE'"
              ><strong>Possível Aprovador:</strong></span
            ><br v-if="slotProps.data.status == 'PENDENTE'" />
            <span>{{ slotProps.data.aprovador }}</span
            ><br />
            <span>{{ slotProps.data.aprovadorUnidade }}</span>
          </div>
        </template>
      </Column>
    </table-seplag>

    <cadastro-rapido
      tituloTela="Justificativa"
      :tamanhoTela="'30.vw'"
      v-model="exibirTelJustificativa"
      textoButtonFechar="Fechar"
      :visivelbotao="true"
    >
      <p
        style="text-align: justify"
        v-html="
          justificativaSelecionada ? justificativaSelecionada : 'Não Informado'
        "
      />
    </cadastro-rapido>
      </template>
  </card-seplag>
</template>
<script>
import CardSeplag from "@/template/CardSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
import { CalcularDias } from "@/common/manipulaData.js";

import moment from "moment";

export default {
  name: "agendamentoLicencaPremioServidor",
  components: { CardSeplag, TableSeplag, Rotulo, CadastroRapido },
  data() {
    return {
      modoEdicao: "adicionar",
      apiUrlRecurso: "lincencaview",
      selectedPeriodoAquisitivo: null,
      parametro: null,
      periodosAquisitivos: [],
      saldoDias: "Não selecionado",
      // data_inicio : moment().format('DD/MM/YYYY'),
      data_inicio: null,
      data_fim: null,
      data_fimEnv: null,
      checkReducaoJornada: false,
      agendamentos: [],
      colunasTabela: [
        { nome: "periodoAquisitivo", titulo: "Quinquênio" },
        { nome: "dataInicio", titulo: "Data Início" },
        { nome: "dataFim", titulo: "Data Término" },
        { nome: "origem", titulo: "Origem" },
      ],
      selectedTipoGozo: { name: null, code: null },
      data_inicio_agendamento: null,
      tiposGozo: [],

      datePikerConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },

      datePikermasks: {
        input: "DD/MM/YYYY",
      },

      max_date: null,
      // min_date: moment().format(),
      min_date: null,
      habilitaAgendamento: false,
      exibirTelJustificativa: false,
      justificativaSelecionada: null,
      periodoJornadaSelecionada: null,
      listaPeriodoJornadaReduzida: ["Matutino", "Vespertino", "Noturno"],
    };
  },
  methods: {
    obterDataMinimaAgendamento() {
      const dataInicioAgendamento = moment(
        this.data_inicio_agendamento,
        "DD/MM/YYYY"
      );
      const datafimPeriodoAquisitivoSelecionado = moment(
        this.selectedPeriodoAquisitivo.dataFim,
        "DD/MM/YYYY"
      );

      if (dataInicioAgendamento < datafimPeriodoAquisitivoSelecionado) {
        if (datafimPeriodoAquisitivoSelecionado < moment()) {
          return moment().add(1, "day");
        }

        return datafimPeriodoAquisitivoSelecionado.clone().add(1, "day");
      }

      return dataInicioAgendamento;
    },
    carregarMaxDate(){
      this.data_inicio = null;
      console.log()
      if (!this.selectedPeriodoAquisitivo) {
        this.max_date = null;
        return;
      }

      let maxDate = new moment(this.selectedPeriodoAquisitivo.dataFim, "DD/MM/YYYY")
        .add(5, "years") // adiciona 5 anos
        .subtract(this.selectedPeriodoAquisitivo.saldoFinal, "days") // subtrai o saldo em dias
        .subtract(this.selectedTipoGozo && this.checkReducaoJornada ? this.selectedTipoGozo.code : 0, "days") //subtrai reducao de jornada
        .locale("pt-br");

      if (maxDate < this.obterDataMinimaAgendamento()) {
        this.max_date = null;
        return;
      }

      this.max_date = maxDate.toDate();
    },
    limparDados() {
      (this.selectedTipoGozo = { name: null, code: null }),
        (this.tiposGozo = []),
        (this.selectedPeriodoAquisitivo = null),
        (this.periodosAquisitivos = []),
        (this.agendamentos = []),
        (this.data_inicio = null),
        (this.data_fim = null);
      this.saldoDias = "Não selecionado";
    },
    calcularData() {
      if (this.selectedTipoGozo) {
        if (this.data_inicio) {
          let checkData = this.data_inicio.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("/", "");
          checkData = checkData.replace("/", "");
          checkData = checkData.split("");
          if (checkData.length > 7) {
            let data_i = new moment(this.data_inicio, "DD/MM/YYYY").locale(
              "pt-br"
            );
            let qtd_dias =
              this.checkReducaoJornada == true &&
              this.selectedTipoGozo.code > 29
                ? this.selectedTipoGozo.code * 2 - 1
                : this.selectedTipoGozo.code - 1;
            let data_f = data_i.locale("pt-br").add(qtd_dias, "days");
            // let data_iFormat = new moment(data_i).format("YYYY-MM-DD")
            // let data_fFormat = new moment(data_f).format("YYYY-MM-DD")
            this.data_fim = data_f.locale("pt-br").format("L");

            /* AJUSTE DA DATA ENVIADA PARA O SERVIÇO*/

            let data_iEnv = new moment(this.data_inicio, "DD/MM/YYYY").locale(
              "pt-br"
            );
            let qtd_diasEnv = this.selectedTipoGozo.code - 1;
            let data_fEnv = data_iEnv.locale("pt-br").add(qtd_diasEnv, "days");
            // let data_iFormatEnv = new moment(data_iEnv).format("YYYY-MM-DD")
            // let data_fFormatEnv = new moment(data_fEnv).format("YYYY-MM-DD")
            this.data_fimEnv = data_fEnv.locale("pt-br").format("L");

            if (this.selectedTipoGozo.code < 30) {
              this.checkReducaoJornada = false;
              this.periodoJornadaSelecionada = null;
            }
          } else {
            this.data_fim = null;
            this.data_fimEnv = null;
          }
        }
      }
    },
    adicionarRegistro() {
      if (this.periodoJornadaSelecionada == null && this.checkReducaoJornada) {
        this.$toast.add({
          severity: "error",
          summary: "Dados Ausentes",
          detail: "Selecione o período em que vai trabalhar",
          life: 4000,
        });
        return;
      }
      if (this.data_inicio == null) {
        this.$toast.add({
          severity: "error",
          summary: "Dados Ausentes",
          detail: "Informe a data de início",
          life: 4000,
        });
        return;
      } else {
        var v_tipoJornada = this.checkReducaoJornada == true ? "S" : "N";
        var programacaoAdicionada = {
          matricula: this.matricula,
          numeroVinculo: this.vinculo,
          chaveperaqlesp: this.selectedPeriodoAquisitivo.chaveperaqlesp,
          diasSolicitados: this.selectedTipoGozo.code,
          dataInicio: this.data_inicio,
          dataFim: this.data_fimEnv,
          jornadaReduzida: v_tipoJornada,
          periodoJornadaReduzida: this.periodoJornadaSelecionada,
        };

        this.$http
          .post(
            `${baseApiUrl}/lincencaview/${this.matricula}/${this.vinculo}`,
            JSON.stringify(programacaoAdicionada)
          )
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary: "Registro Adicionado com Sucesso!",
              life: 3000,
            });
            this.selectedTipoGozo.code = null;
            this.limparDados();
            this.carregarDados();
          });
        //.catch(error => {
        //    for(let i=0;i<error.response.data.length;i++){
        //        this.$toast.add({severity:'error', summary:error.response.data[i].msgUsuario, life: 3000})
        //    }
        //})
      }
    },
    carregarCamposAgendamento() {
      this.carregarMaxDate()
      if (this.selectedPeriodoAquisitivo) {
        this.tiposGozo = [];
        this.selectedTipoGozo = null;
        this.saldoDias = this.selectedPeriodoAquisitivo.saldoFinal + " dias";
        for (var item in this.selectedPeriodoAquisitivo
          .diasPossivelAgendamento) {
          var v_tiposGozo = {
            name:
              this.selectedPeriodoAquisitivo.diasPossivelAgendamento[item]
                .dias + " dias",
            code: this.selectedPeriodoAquisitivo.diasPossivelAgendamento[item]
              .dias,
          };
          this.tiposGozo.push(v_tiposGozo);
        }
        this.selectedTipoGozo = this.tiposGozo[0];

        // let dataPeriodo = this.selectedPeriodoAquisitivo.descPeriodo.split(' ')
        //SELECIONA O ULTIMO DIA DO ANO DA DATA DE INICIO DE AGENDAMENTO

        let dataMinimaAgendamento = this.obterDataMinimaAgendamento();
        this.data_inicio = dataMinimaAgendamento.format("DD/MM/YYYY");
        this.min_date = dataMinimaAgendamento.format();
        this.calcularData();
      } else {
        this.selectedTipoGozo = { name: null, code: null };
        this.tiposGozo = [];
        this.saldoDias = "Não selecionado";
      }
    },
    carregarDados() {
      this.matricula = this.$store.getters.getMatricula;
      this.vinculo = this.$store.getters.getVinculo;
      this.selectedPeriodoAquisitivo = null;

      let vinculoAtivo = this.vinculo;
      let vinculoSelecionado =
        this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor.filter(
          function (element) {
            return element.numVinculo == vinculoAtivo;
          }
        );
      if (vinculoSelecionado.length > 0 && vinculoSelecionado[0].idenOrgao) {
        this.$http
          .post(
            `${baseApiUrl}/parametro/busca`,
            JSON.stringify({
              busca: "PERMISSAO_LICENCA_PREMIO",
              idenSistema: process.env.VUE_APP_CODIGO_SISTEMA,
            })
          )
          .then((res) => {
            if (res.data.totalElements > 0) {
              this.parametro = res.data.content[0];
              this.$http
                .get(
                  `${baseApiUrl}/parametro/orgao/${res.data.content[0].idenParametro}/${vinculoSelecionado[0].codgSeap}`
                )
                .then((res3) => {
                  if (
                    (res3.data && res3.data.valorParametro == "HABILITADO") ||
                    (!res3.data &&
                      res.data.content[0].valorParametro == "HABILITADO")
                  ) {
                    this.data_inicio_agendamento = new moment()
                      .add(1, "day")
                      .format("DD/MM/YYYY");
                    // this.data_inicio_agendamento  =   '01/01/2024'
                    this.$http
                      .get(
                        `${baseApiUrl}/${this.apiUrlRecurso}/${this.matricula}/${this.vinculo}`
                      )
                      .then((res) => {
                        this.periodosAquisitivos = [];
                        for (var item in res.data) {
                          var v_pAquisitivo = {
                            ...res.data[item],
                            descPeriodo:
                              res.data[item].dataInicio +
                              " à " +
                              res.data[item].dataFim,
                          };
                          this.periodosAquisitivos.push(v_pAquisitivo);
                        }
                      });
                    this.habilitaAgendamento = true;
                  }
                });
            }
          });
      }
      this.carregarDadosAgendamento();
    },
    async carregarDadosAgendamento() {
      var v_agendamentos = await this.$http.get(
        `${baseApiUrl}/lincencaview/historico/${this.matricula}/${this.vinculo}`
      );
      if (v_agendamentos.status == 200) {
        const registros = v_agendamentos.data;
        this.agendamentos = [];

        for (var item in registros) {
          let aprovador = registros[item].aprovador;
          if (aprovador && typeof aprovador === "string") {
            aprovador = JSON.parse(aprovador);
          }
          var v_programacao = {
            periodoAquisitivo:
              registros[item].dataInicioPeriodoAquisitivo +
              " à " +
              registros[item].dataFimPeriodoAquisitivo,
            diasSolicitados: CalcularDias(
              registros[item].dataInicio,
              registros[item].dataFim
            ),
            dataInicio: registros[item].dataInicio,
            dataFim: registros[item].dataFim,
            origem: registros[item].origem,
            status: registros[item].status,
            tipoJornada: registros[item].periodoJornadaReduzida
              ? "REDUZIDA"
              : "INTEGRAL",
            observacao: registros[item].observacao,
            aprovador:
              registros[item].aprovador && aprovador
                ? aprovador.nome
                : "",
            aprovadorUnidade:
              registros[item].aprovador && aprovador
                ? aprovador.nomeSetor
                : "",
          };
          this.agendamentos.push(v_programacao);
        }
      }
    },
    showModalJustificativa(justificativa) {
      if (justificativa) {
        this.justificativaSelecionada = justificativa;
        this.exibirTelJustificativa = true;
      } else {
        this.$toast.add({
          severity: "error",
          summary: "justificativa Não Cadastrada",
          life: 3000,
        });
      }
    },
  },
  mounted() {
    if (this.bloquearAgendamentoLicencaPremio) {
      return;
    }
    this.carregarDados();
  },
};
</script>
<style scoped>

.dashboard > div {
  padding: 1em;
}
.dashboard .dashboard-grid {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding: 0;
}
.p-text-center {
  text-align: center;
}
.dashboard .card {
  height: 100%;
  margin-bottom: 0;
}
.dashboard .summary-box {
  position: relative;
}
.dashboard .summary-box .card {
  min-height: 100px;
}
.dashboard .summary-box .summary-box-title {
  font-size: 2em;
  margin: 0;
  color: #ffffff;
}
.dashboard .summary-box p {
  margin: 0.25em 0;
  color: #ffffff;
}
.dashboard .summary-box .summary-box-icon {
  position: absolute;
  font-size: 5em;
  right: 24px;
  top: 32px;
}
.dashboard .summary-box .summary-box-graph {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.dashboard .summary-box.summary-box-azul .card {
  border-top: 4px solid #0097a7;
  background-color: #00bcd4;
}
.dashboard .summary-box.summary-box-azul .ico {
  color: #0097a7;
}
.dashboard .summary-box.summary-box-rosa .card {
  border-top: 4px solid #ad1457;
  background-color: #e91e63;
}
.dashboard .summary-box.summary-box-rosa .ico {
  color: #ad1457;
}
.dashboard .summary-box.summary-box-amarelo .card {
  border-top: 4px solid #f47b08;
  background-color: #ffb300;
}
.dashboard .summary-box.summary-box-amarelo .ico {
  color: #f47b08;
}
.dashboard .summary-box.summary-box-cinza .card {
  border-top: 4px solid #455a64;
  background-color: #607d8b;
}
.dashboard .summary-box.summary-box-cinza .ico {
  color: #455a64;
}

/* STATUS DA PROGRAMAÇÃO
    APROVADO
    PENDENTE
    REPROVADO
    VALIDADO
    PUBLICADO
    */
.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.status-APROVADO {
  background-color: #c8e6c9;
  color: #256029;
}

.status-APROVADO:active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADO:hover {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADO:focus {
  box-shadow: 0 0 0 0.2rem #c8e6c9;
}
.status-APROVADORH {
  background-color: #c8e6c9;
  color: #256029;
}

.status-APROVADORH:active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADORH:hover {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADORH:focus {
  box-shadow: 0 0 0 0.2rem #c8e6c9;
}

.status-REPROVADO {
  background-color: #ffcdd2;
  color: #c63737;
}

.status-REPROVADO:active {
  background-color: #ffcdd2 !important;
  color: #c63737 !important;
}

.status-REPROVADO:hover {
  background-color: #ffcdd2 !important;
  color: #c63737 !important;
}

.status-REPROVADO:focus {
  box-shadow: 0 0 0 0.2rem #ffcdd2;
}

.status-PENDENTE {
  background-color: #feedaf;
  color: #8a5340;
}

.status-PENDENTE:active {
  background-color: #feedaf !important;
  color: #8a5340 !important;
}

.status-PENDENTE:hover {
  background-color: #feedaf !important;
  color: #8a5340 !important;
}

.status-PENDENTE:focus {
  box-shadow: 0 0 0 0.2rem #feedaf;
}

.status-PUBLICADO {
  background-color: #b3e5fc;
  color: #23547b;
}

.status-PUBLICADO:active {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-PUBLICADO:hover {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-PUBLICADO:focus {
  box-shadow: 0 0 0 0.2rem #b3e5fc;
}

.status-VALIDADO {
  background-color: #eccfff;
  color: #694382;
}

.status-VALIDADO:active {
  background-color: #eccfff !important;
  color: #694382 !important;
}

.status-VALIDADO:hover {
  background-color: #eccfff !important;
  color: #694382 !important;
}

.status-VALIDADO:focus {
  box-shadow: 0 0 0 0.2rem #eccfff;
}

.status-VIASEAP {
  background-color: #b4b3af;
  color: #3f3e3d;
}

.status-VIASEAP:active {
  background-color: #b4b3af !important;
  color: #3f3e3d !important;
}

.status-VIASEAP:hover {
  background-color: #b4b3af !important;
  color: #3f3e3d !important;
}

.status-VIASEAP:focus {
  box-shadow: 0 0 0 0.2rem #b4b3af;
}

.status-FINALIZADO {
  background-color: #b3e5fc;
  color: #23547b;
}

.status-FINALIZADO:active {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-FINALIZADO:hover {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-FINALIZADO:focus {
  box-shadow: 0 0 0 0.2rem #b3e5fc;
}

.status-proposal {
  background-color: #ffd8b2;
  color: #805b36;
}

/* status 
        .status-Usufruido {
            font-weight: bold;
            color: #23547B;
        }
        .status-Agendado {
            font-weight: bold;
            color: #256029;
        }
        .status-Aguardando {
            font-weight: bold;
            color: yellowgreen;
        }*/
</style>
